import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {
  CreditCardDirective,
  EqualValidatorDirective,
  PhoneDirective
} from './directives';

import {
  FilterCardStatePipe
} from './pipes';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    CreditCardDirective,
    EqualValidatorDirective,
    FilterCardStatePipe,
    PhoneDirective,
    SafePipe,
    SidebarComponent
  ],
  declarations: [
    CreditCardDirective,
    EqualValidatorDirective,
    FilterCardStatePipe,
    PhoneDirective,
    SidebarComponent,
    SafePipe
  ],
  providers: [
    FilterCardStatePipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/shared.module.ts